"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var actions = _interopRequireWildcard(require("./store/personalTemplateSettings.actions"));

var selectors = _interopRequireWildcard(require("./store/personalTemplateSettings.selectors"));

var _TemplatesSearch = _interopRequireDefault(require("./components/TemplatesSearch"));

var _TemplatesList = _interopRequireDefault(require("./components/TemplatesList"));

var _TemplateItem = _interopRequireDefault(require("./components/TemplateItem"));

var PersonalTemplateSettings = function PersonalTemplateSettings() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      editTemplateId = _useState4[0],
      setEditTemplateId = _useState4[1];

  var hasErrors = (0, _reactRedux.useSelector)(selectors.getHasErrors);
  var isLoaded = (0, _reactRedux.useSelector)(selectors.getIsLoaded);
  var lastModifiedTemplateId = (0, _reactRedux.useSelector)(selectors.getLastModifiedTemplateId);
  (0, _react.useEffect)(function () {
    dispatch(actions.getTemplatesRequest());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (lastModifiedTemplateId) {
      setEditTemplateId(lastModifiedTemplateId);
    }
  }, [lastModifiedTemplateId]);
  var handleSearch = (0, _react.useCallback)(function (event) {
    setSearch(event.currentTarget.value.trimLeft());
  }, []);
  var handleSearchReset = (0, _react.useCallback)(function () {
    setSearch('');
  }, []);
  var handleCreateTemplate = (0, _react.useCallback)(function () {
    setEditTemplateId(0);
  }, []);
  var handleCreate = (0, _react.useCallback)(function (template) {
    dispatch(actions.createTemplate(template));
  }, [dispatch]);
  var handleToggleEdit = (0, _react.useCallback)(function (id) {
    if (hasErrors) {
      dispatch(actions.resetErrors());
    }

    setEditTemplateId(function (current) {
      return current === id ? undefined : id;
    });
  }, [dispatch, hasErrors]);
  var handleToggleCreate = (0, _react.useCallback)(function () {
    setEditTemplateId(function (current) {
      return current === 0 ? undefined : 0;
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    bgcolor: "common.white",
    boxShadow: 1,
    mt: 3,
    borderRadius: "5px",
    p: 4
  }, /*#__PURE__*/_react.default.createElement(_TemplatesSearch.default, {
    search: search,
    onSearch: handleSearch,
    onReset: handleSearchReset,
    onClickCreate: handleCreateTemplate,
    disabled: !isLoaded
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: editTemplateId === 0,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    my: 4,
    shift: -8,
    mx: -4
  }), /*#__PURE__*/_react.default.createElement(_TemplateItem.default, {
    onToggleEdit: handleToggleCreate,
    onSave: handleCreate
  })), /*#__PURE__*/_react.default.createElement(_TemplatesList.default, {
    editTemplateId: editTemplateId,
    onToggleEdit: handleToggleEdit,
    search: search
  })));
};

PersonalTemplateSettings.propTypes = {};
var _default = PersonalTemplateSettings;
exports.default = _default;